const { MODE } = import.meta.env;

export const IS_LOCAL = MODE === 'localhost';
export const IS_DEV = MODE === 'development';
export const IS_PROD = MODE === 'production' || MODE === 'staging';
export const VITE_ASSETS_VARIANT = import.meta.env.VITE_ASSETS_VARIANT || 'stepball';
export const IS_STEPBALL = VITE_ASSETS_VARIANT === 'stepball';
export const IS_CHEZACHINI = VITE_ASSETS_VARIANT === 'chezachini';
export const GAME_HOST = `${VITE_ASSETS_VARIANT}.dev.betskilla.com`;
export const API_URL = IS_LOCAL ? `https://${GAME_HOST}/api` : `/api`;
export const SOCKET_URL = IS_LOCAL ? `wss://${GAME_HOST}/` : `/`;
export const GAME_ID = `leprecoins_${VITE_ASSETS_VARIANT}`;
export const GAME_PROVIDER_ID = 'leprecoins';
export const PLATFORM_RETURN_URL = 'https://demo.betskilla.com';
export const API_PLATFORM_URL = 'https://api.demo.betskilla.com/api';
export const CRITICAL_ERROR_CODES = [300, 302, 304, 301];
